import { Box, CircularProgress } from '@ori-ui/mui';

export const Loading = () => (
  <Box
    alignItems="center"
    display="flex"
    flexDirection="column"
    height="100%"
    justifyContent="center"
    textAlign="center"
    width="100%"
  >
    <CircularProgress color="primary" />
  </Box>
);
